/**
 * Itinerary Constants
 *
 * Geographic constants used for validating itinerary activities.
 * Extracted from WanderAppComplete.jsx for testability and reuse.
 */

// City-to-country mapping for cross-country validation
export const CITY_TO_COUNTRY = {
  'bogota': 'Colombia', 'medellin': 'Colombia', 'cartagena': 'Colombia',
  'lima': 'Peru', 'cusco': 'Peru', 'arequipa': 'Peru',
  'buenos aires': 'Argentina', 'mendoza': 'Argentina', 'el calafate': 'Argentina', 'ushuaia': 'Argentina', 'bariloche': 'Argentina', 'san carlos de bariloche': 'Argentina', 'iguazu': 'Argentina', 'puerto iguazu': 'Argentina', 'salta': 'Argentina', 'cordoba': 'Argentina',
  'santiago': 'Chile', 'valparaiso': 'Chile', 'puerto natales': 'Chile', 'punta arenas': 'Chile', 'torres del paine': 'Chile', 'patagonia': 'Chile',
  'rio de janeiro': 'Brazil', 'sao paulo': 'Brazil',
  'mexico city': 'Mexico', 'cancun': 'Mexico', 'oaxaca': 'Mexico', 'tulum': 'Mexico',
  'paris': 'France', 'nice': 'France', 'lyon': 'France', 'marseille': 'France', 'bordeaux': 'France',
  'cannes': 'France', 'saint-tropez': 'France', 'antibes': 'France', 'avignon': 'France', 'montpellier': 'France',
  'biarritz': 'France', 'strasbourg': 'France', 'colmar': 'France', 'annecy': 'France', 'aix-en-provence': 'France',
  'rome': 'Italy', 'florence': 'Italy', 'venice': 'Italy', 'milan': 'Italy', 'naples': 'Italy', 'amalfi': 'Italy', 'cinque terre': 'Italy',
  'positano': 'Italy', 'ravello': 'Italy', 'sorrento': 'Italy', 'taormina': 'Italy', 'siena': 'Italy',
  'lucca': 'Italy', 'verona': 'Italy', 'como': 'Italy', 'portofino': 'Italy', 'capri': 'Italy',
  'barcelona': 'Spain', 'madrid': 'Spain', 'seville': 'Spain', 'granada': 'Spain', 'valencia': 'Spain',
  'malaga': 'Spain', 'cadiz': 'Spain', 'san sebastian': 'Spain', 'bilbao': 'Spain', 'cordoba': 'Spain',
  'tarifa': 'Spain', 'ronda': 'Spain', 'marbella': 'Spain', 'salamanca': 'Spain', 'toledo': 'Spain',
  'london': 'UK', 'edinburgh': 'UK', 'manchester': 'UK', 'liverpool': 'UK', 'oxford': 'UK', 'cambridge': 'UK',
  'berlin': 'Germany', 'munich': 'Germany', 'frankfurt': 'Germany', 'hamburg': 'Germany', 'cologne': 'Germany',
  'amsterdam': 'Netherlands', 'rotterdam': 'Netherlands', 'utrecht': 'Netherlands',
  'tokyo': 'Japan', 'kyoto': 'Japan', 'osaka': 'Japan', 'hiroshima': 'Japan', 'nara': 'Japan', 'sapporo': 'Japan', 'niseko': 'Japan', 'hakuba': 'Japan', 'nagano': 'Japan', 'fukuoka': 'Japan',
  'bangkok': 'Thailand', 'chiang mai': 'Thailand', 'phuket': 'Thailand', 'krabi': 'Thailand',
  'singapore': 'Singapore',
  'hong kong': 'Hong Kong',
  'istanbul': 'Turkey', 'cappadocia': 'Turkey', 'antalya': 'Turkey',
  'athens': 'Greece', 'santorini': 'Greece', 'mykonos': 'Greece', 'crete': 'Greece',
  'thessaloniki': 'Greece', 'nafplio': 'Greece', 'meteora': 'Greece', 'zakynthos': 'Greece', 'naxos': 'Greece', 'paros': 'Greece', 'milos': 'Greece',
  'dubai': 'UAE', 'abu dhabi': 'UAE',
  'cairo': 'Egypt', 'luxor': 'Egypt', 'aswan': 'Egypt',
  'marrakech': 'Morocco', 'fes': 'Morocco', 'casablanca': 'Morocco',
  'cape town': 'South Africa', 'johannesburg': 'South Africa',
  'sydney': 'Australia', 'melbourne': 'Australia', 'brisbane': 'Australia', 'perth': 'Australia',
  'auckland': 'New Zealand', 'queenstown': 'New Zealand', 'wellington': 'New Zealand',
  'christchurch': 'New Zealand', 'rotorua': 'New Zealand', 'napier': 'New Zealand', 'nelson': 'New Zealand',
  'dunedin': 'New Zealand', 'taupo': 'New Zealand', 'hamilton': 'New Zealand', 'tauranga': 'New Zealand',
  // Antarctica: treated as its own "country" so the resolver can map it to the Antarctica continent
  // (prevents LLM from emitting short/bogus flights like "Christchurch→Antarctica 1.5h")
  'antarctica': 'Antarctica', 'ross sea': 'Antarctica', 'mcmurdo station': 'Antarctica', 'king george island': 'Antarctica',
  'hanoi': 'Vietnam', 'ho chi minh': 'Vietnam', 'da nang': 'Vietnam', 'hoi an': 'Vietnam',
  'bali': 'Indonesia', 'jakarta': 'Indonesia', 'yogyakarta': 'Indonesia',
  'kuala lumpur': 'Malaysia', 'penang': 'Malaysia', 'langkawi': 'Malaysia',
  'lisbon': 'Portugal', 'porto': 'Portugal', 'faro': 'Portugal',
  'sintra': 'Portugal', 'cascais': 'Portugal', 'ericeira': 'Portugal', 'nazare': 'Portugal',
  'obidos': 'Portugal', 'coimbra': 'Portugal', 'braga': 'Portugal', 'guimaraes': 'Portugal',
  'aveiro': 'Portugal', 'evora': 'Portugal', 'lagos': 'Portugal', 'tavira': 'Portugal',
  'albufeira': 'Portugal', 'comporta': 'Portugal', 'setubal': 'Portugal', 'peniche': 'Portugal',
  'pinhao': 'Portugal', 'tomar': 'Portugal', 'estoril': 'Portugal', 'sesimbra': 'Portugal',
  'matosinhos': 'Portugal', 'gaia': 'Portugal', 'espinho': 'Portugal', 'povoa de varzim': 'Portugal', 'vila do conde': 'Portugal',
  'prague': 'Czech Republic', 'vienna': 'Austria', 'budapest': 'Hungary', 'salzburg': 'Austria',
  'dublin': 'Ireland', 'galway': 'Ireland', 'cork': 'Ireland',
  'reykjavik': 'Iceland',
  'stockholm': 'Sweden', 'copenhagen': 'Denmark', 'oslo': 'Norway', 'helsinki': 'Finland',
  'interlaken': 'Switzerland', 'zurich': 'Switzerland', 'geneva': 'Switzerland', 'lucerne': 'Switzerland', 'bern': 'Switzerland', 'zermatt': 'Switzerland',
  'brussels': 'Belgium', 'bruges': 'Belgium', 'antwerp': 'Belgium',
  'warsaw': 'Poland', 'krakow': 'Poland',
  'seoul': 'South Korea', 'busan': 'South Korea',
  'taipei': 'Taiwan',
  'beijing': 'China', 'shanghai': 'China', 'xian': 'China', 'guangzhou': 'China', 'shenzhen': 'China',
  'mumbai': 'India', 'delhi': 'India', 'jaipur': 'India', 'goa': 'India', 'agra': 'India',
  'puerto vallarta': 'Mexico', 'los cabos': 'Mexico', 'cabo san lucas': 'Mexico', 'playa del carmen': 'Mexico',
  // US mainland cities
  'new york': 'USA', 'los angeles': 'USA', 'san francisco': 'USA', 'chicago': 'USA', 'miami': 'USA',
  'boston': 'USA', 'washington': 'USA', 'washington dc': 'USA', 'seattle': 'USA', 'denver': 'USA',
  'las vegas': 'USA', 'phoenix': 'USA', 'atlanta': 'USA', 'dallas': 'USA', 'houston': 'USA',
  'austin': 'USA', 'nashville': 'USA', 'new orleans': 'USA', 'orlando': 'USA', 'san diego': 'USA',
  'portland': 'USA', 'philadelphia': 'USA', 'minneapolis': 'USA', 'charlotte': 'USA', 'savannah': 'USA',
  'honolulu': 'USA', 'maui': 'USA', 'hawaii': 'USA', 'anchorage': 'USA', 'charleston': 'USA',
  // US territories
  'san juan': 'USA', 'puerto rico': 'USA', 'guam': 'USA', 'us virgin islands': 'USA',
  'st thomas': 'USA', 'st croix': 'USA', 'american samoa': 'USA',
  // French overseas territories
  'réunion': 'France', 'reunion': 'France', 'martinique': 'France', 'guadeloupe': 'France',
  'new caledonia': 'French Polynesia', 'tahiti': 'French Polynesia', 'bora bora': 'French Polynesia', 'moorea': 'French Polynesia',
  // Dutch Caribbean
  'aruba': 'Netherlands', 'curacao': 'Netherlands', 'curaçao': 'Netherlands', 'bonaire': 'Netherlands',
  // UK territories
  'bermuda': 'UK', 'gibraltar': 'UK', 'cayman islands': 'UK',
  // Portuguese territories
  'madeira': 'Portugal', 'azores': 'Portugal', 'funchal': 'Portugal',
  // Spanish territories
  'tenerife': 'Spain', 'gran canaria': 'Spain', 'lanzarote': 'Spain', 'fuerteventura': 'Spain',
  'mallorca': 'Spain', 'ibiza': 'Spain', 'menorca': 'Spain', 'las palmas': 'Spain',
  // Italian islands
  'sicily': 'Italy', 'sardinia': 'Italy',
  // Danish territory
  'tórshavn': 'Denmark', 'torshavn': 'Denmark', 'faroe islands': 'Denmark', 'faroe': 'Denmark',
  // Greek islands
  'rhodes': 'Greece', 'corfu': 'Greece', 'kos': 'Greece', 'kefalonia': 'Greece', 'skiathos': 'Greece',
  // Croatian coast
  'dubrovnik': 'Croatia', 'split': 'Croatia', 'zagreb': 'Croatia', 'hvar': 'Croatia', 'zadar': 'Croatia', 'pula': 'Croatia', 'rovinj': 'Croatia',
  // Malta
  'malta': 'Malta', 'valletta': 'Malta', 'gozo': 'Malta', 'mdina': 'Malta',
  // Cyprus
  'cyprus': 'Cyprus', 'nicosia': 'Cyprus', 'limassol': 'Cyprus', 'paphos': 'Cyprus', 'larnaca': 'Cyprus', 'ayia napa': 'Cyprus',
  // Oman
  'oman': 'Oman', 'muscat': 'Oman', 'salalah': 'Oman', 'nizwa': 'Oman',
  // Montenegro
  'kotor': 'Montenegro', 'budva': 'Montenegro', 'podgorica': 'Montenegro', 'tivat': 'Montenegro',
  // Slovenia
  'ljubljana': 'Slovenia', 'bled': 'Slovenia', 'piran': 'Slovenia',
  // Romania
  'bucharest': 'Romania', 'brasov': 'Romania', 'sibiu': 'Romania', 'cluj-napoca': 'Romania',
  // Serbia
  'belgrade': 'Serbia', 'novi sad': 'Serbia',
  // Bosnia
  'sarajevo': 'Bosnia', 'mostar': 'Bosnia',
  // Georgia
  'tbilisi': 'Georgia', 'batumi': 'Georgia',
  // Jordan
  'amman': 'Jordan', 'petra': 'Jordan', 'aqaba': 'Jordan', 'wadi rum': 'Jordan', 'dead sea': 'Jordan',
  // Israel
  'tel aviv': 'Israel', 'jerusalem': 'Israel', 'haifa': 'Israel', 'eilat': 'Israel',
  // Canada
  'toronto': 'Canada', 'vancouver': 'Canada', 'montreal': 'Canada', 'quebec city': 'Canada', 'ottawa': 'Canada', 'calgary': 'Canada', 'banff': 'Canada', 'victoria': 'Canada', 'whistler': 'Canada',
  // Other notable destinations
  'maldives': 'Maldives', 'male': 'Maldives',
  'zanzibar': 'Tanzania',
  'seychelles': 'Seychelles', 'mauritius': 'Mauritius',
  'fiji': 'Fiji', 'suva': 'Fiji', 'nadi': 'Fiji',
  'havana': 'Cuba', 'nassau': 'Bahamas', 'kingston': 'Jamaica',
  'okinawa': 'Japan',
  'jeju': 'South Korea',
  'tasmania': 'Australia', 'hobart': 'Australia',
  // Additional SE Asia
  'siem reap': 'Cambodia', 'phnom penh': 'Cambodia',
  'luang prabang': 'Laos', 'vientiane': 'Laos',
  'yangon': 'Myanmar', 'mandalay': 'Myanmar', 'bagan': 'Myanmar',
  'manila': 'Philippines', 'cebu': 'Philippines', 'palawan': 'Philippines', 'boracay': 'Philippines',
  // Additional Africa
  'nairobi': 'Kenya', 'mombasa': 'Kenya', 'masai mara': 'Kenya',
  'dar es salaam': 'Tanzania', 'serengeti': 'Tanzania', 'arusha': 'Tanzania',
  'kigali': 'Rwanda',
  'addis ababa': 'Ethiopia', 'lalibela': 'Ethiopia',
  'windhoek': 'Namibia', 'swakopmund': 'Namibia',
  'victoria falls': 'Zimbabwe',
  // Additional South America
  'montevideo': 'Uruguay', 'punta del este': 'Uruguay',
  'quito': 'Ecuador', 'galapagos': 'Ecuador', 'cuenca': 'Ecuador',
  'la paz': 'Bolivia', 'uyuni': 'Bolivia',
  'san jose': 'Costa Rica', 'manuel antonio': 'Costa Rica', 'la fortuna': 'Costa Rica',
  // Nepal / Sri Lanka
  'kathmandu': 'Nepal', 'pokhara': 'Nepal',
  'colombo': 'Sri Lanka', 'kandy': 'Sri Lanka', 'galle': 'Sri Lanka', 'ella': 'Sri Lanka',
  // Mongolia
  'ulaanbaatar': 'Mongolia',
};

// Known unrealistic day-trip pairs (5+ hours each way)
export const UNREALISTIC_DAY_TRIP_PAIRS = new Set([
  'puerto natales-el calafate', 'el calafate-puerto natales',
  'torres del paine-el calafate', 'el calafate-torres del paine',
  'punta arenas-el calafate', 'el calafate-punta arenas',
  'puerto natales-ushuaia', 'ushuaia-puerto natales',
  'el calafate-ushuaia', 'ushuaia-el calafate',
  'buenos aires-mendoza', 'mendoza-buenos aires',
  'buenos aires-bariloche', 'bariloche-buenos aires',
  'buenos aires-el calafate', 'el calafate-buenos aires',
  'buenos aires-ushuaia', 'ushuaia-buenos aires',
  'lima-cusco', 'cusco-lima',
  'lima-arequipa', 'arequipa-lima',
  'los angeles-san francisco', 'san francisco-los angeles',
  'new york-washington dc', 'washington dc-new york',
  'paris-barcelona', 'barcelona-paris',
  'london-paris', 'paris-london',
  'rome-florence', 'florence-rome',
  'sydney-melbourne', 'melbourne-sydney',
  'sydney-brisbane', 'brisbane-sydney',
  // Japan ski resort areas (2+ hours between each)
  'niseko-sapporo', 'sapporo-niseko',
  'niseko-otaru', 'otaru-niseko',
  'hakuba-nagano', 'nagano-hakuba',
]);

// Known distant locations that should not appear as same-day activities
export const DISTANT_LOCATION_PATTERNS = [
  { baseCity: 'puerto natales', distantLocations: ['el calafate', 'perito moreno', 'glaciarium', 'los glaciares national park'] },
  { baseCity: 'torres del paine', distantLocations: ['el calafate', 'perito moreno', 'glaciarium'] },
  { baseCity: 'el calafate', distantLocations: ['puerto natales', 'torres del paine', 'punta arenas'] },
  { baseCity: 'cusco', distantLocations: ['lima', 'arequipa', 'nazca'] },
  { baseCity: 'lima', distantLocations: ['cusco', 'machu picchu', 'arequipa'] },
  { baseCity: 'buenos aires', distantLocations: ['mendoza', 'bariloche', 'el calafate', 'ushuaia', 'iguazu'] },
  // Japan ski resort areas
  { baseCity: 'niseko', distantLocations: ['sapporo', 'otaru', 'chitose', 'noboribetsu'] },
  { baseCity: 'sapporo', distantLocations: ['niseko', 'furano', 'tomamu', 'hakuba'] },
  { baseCity: 'hakuba', distantLocations: ['nagano', 'matsumoto', 'tokyo', 'karuizawa'] },
];

// Known major cities for cross-city validation
export const KNOWN_CITIES = [
  'tokyo', 'kyoto', 'osaka', 'sapporo', 'hakuba', 'niseko', 'nagoya', 'hiroshima', 'fukuoka', 'nara', 'kobe',
  'paris', 'lyon', 'marseille', 'nice', 'bordeaux',
  'rome', 'florence', 'venice', 'milan', 'naples',
  'london', 'edinburgh', 'manchester', 'liverpool',
  'barcelona', 'madrid', 'seville', 'granada',
  'berlin', 'munich', 'hamburg', 'frankfurt',
  'bangkok', 'chiang mai', 'phuket', 'pattaya',
  'bali', 'jakarta', 'ubud', 'seminyak',
  'new york', 'los angeles', 'san francisco', 'chicago', 'miami',
  'sydney', 'melbourne', 'brisbane', 'perth'
];

// ============================================
// EMOJI TYPE MAP — activity type → emoji
// ============================================

export const EMOJI_TYPE_MAP = {
  sightseeing: '🏛️',
  culture: '🎭',
  food: '🍽️',
  outdoor: '🌿',
  nature: '🌿',
  beach: '🏖️',
  adventure: '🧗',
  nightlife: '🌙',
  shopping: '🛍️',
  wellness: '💆',
  spa: '💆',
  museum: '🖼️',
  temple: '⛩️',
  historical: '🏰',
  photography: '📸',
  wildlife: '🦁',
  diving: '🤿',
  snorkeling: '🤿',
  skiing: '⛷️',
  hiking: '🥾',
  transit: '✈️',
  transport: '✈️',
  relaxation: '😌',
  entertainment: '🎉',
  sports: '⚽',
  yoga: '🧘',
  market: '🛒',
  wine: '🍷',
  brewery: '🍺',
  cooking: '👨‍🍳',
  art: '🎨',
  music: '🎵',
  festival: '🎪',
  cruise: '🚢',
  safari: '🦒',
  default: '📍',
};

// ============================================
// COUNTRY TO CURRENCY — for wrong-currency detection
// ============================================

export const COUNTRY_TO_CURRENCY = {
  'france': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'italy': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'spain': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'germany': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'netherlands': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'portugal': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'greece': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'austria': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'belgium': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'ireland': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'finland': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'uk': { code: 'GBP', symbol: '£', approxUsdRate: 0.79 },
  'japan': { code: 'JPY', symbol: '¥', approxUsdRate: 150 },
  'thailand': { code: 'THB', symbol: '฿', approxUsdRate: 35 },
  'indonesia': { code: 'IDR', symbol: 'Rp', approxUsdRate: 15500 },
  'india': { code: 'INR', symbol: '₹', approxUsdRate: 83 },
  'south korea': { code: 'KRW', symbol: '₩', approxUsdRate: 1350 },
  'china': { code: 'CNY', symbol: '¥', approxUsdRate: 7.2 },
  'mexico': { code: 'MXN', symbol: 'MX$', approxUsdRate: 17 },
  'brazil': { code: 'BRL', symbol: 'R$', approxUsdRate: 5 },
  'turkey': { code: 'TRY', symbol: '₺', approxUsdRate: 32 },
  'egypt': { code: 'EGP', symbol: 'E£', approxUsdRate: 48 },
  'morocco': { code: 'MAD', symbol: 'MAD', approxUsdRate: 10 },
  'south africa': { code: 'ZAR', symbol: 'R', approxUsdRate: 18 },
  'australia': { code: 'AUD', symbol: 'A$', approxUsdRate: 1.55 },
  'new zealand': { code: 'NZD', symbol: 'NZ$', approxUsdRate: 1.7 },
  'canada': { code: 'CAD', symbol: 'C$', approxUsdRate: 1.37 },
  'switzerland': { code: 'CHF', symbol: 'CHF', approxUsdRate: 0.88 },
  'norway': { code: 'NOK', symbol: 'kr', approxUsdRate: 11 },
  'sweden': { code: 'SEK', symbol: 'kr', approxUsdRate: 11 },
  'denmark': { code: 'DKK', symbol: 'kr', approxUsdRate: 7 },
  'iceland': { code: 'ISK', symbol: 'kr', approxUsdRate: 140 },
  'czech republic': { code: 'CZK', symbol: 'Kč', approxUsdRate: 23 },
  'hungary': { code: 'HUF', symbol: 'Ft', approxUsdRate: 370 },
  'poland': { code: 'PLN', symbol: 'zł', approxUsdRate: 4 },
  'croatia': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'argentina': { code: 'ARS', symbol: 'AR$', approxUsdRate: 900 },
  'colombia': { code: 'COP', symbol: 'COL$', approxUsdRate: 4000 },
  'peru': { code: 'PEN', symbol: 'S/', approxUsdRate: 3.75 },
  'chile': { code: 'CLP', symbol: 'CL$', approxUsdRate: 950 },
  'vietnam': { code: 'VND', symbol: '₫', approxUsdRate: 25000 },
  'malaysia': { code: 'MYR', symbol: 'RM', approxUsdRate: 4.7 },
  'philippines': { code: 'PHP', symbol: '₱', approxUsdRate: 57 },
  'singapore': { code: 'SGD', symbol: 'S$', approxUsdRate: 1.35 },
  'taiwan': { code: 'TWD', symbol: 'NT$', approxUsdRate: 32 },
  'uae': { code: 'AED', symbol: 'AED', approxUsdRate: 3.67 },
  'qatar': { code: 'QAR', symbol: 'QR', approxUsdRate: 3.64 },
  'israel': { code: 'ILS', symbol: '₪', approxUsdRate: 3.7 },
  'jordan': { code: 'JOD', symbol: 'JD', approxUsdRate: 0.71 },
  'oman': { code: 'OMR', symbol: 'OMR', approxUsdRate: 0.385 },
  'kenya': { code: 'KES', symbol: 'KSh', approxUsdRate: 155 },
  'tanzania': { code: 'TZS', symbol: 'TSh', approxUsdRate: 2700 },
  'rwanda': { code: 'RWF', symbol: 'FRw', approxUsdRate: 1300 },
  'sri lanka': { code: 'LKR', symbol: 'Rs', approxUsdRate: 300 },
  'nepal': { code: 'NPR', symbol: 'Rs', approxUsdRate: 133 },
  'maldives': { code: 'USD', symbol: '$', approxUsdRate: 1 },
  'cambodia': { code: 'USD', symbol: '$', approxUsdRate: 1 },
  'costa rica': { code: 'CRC', symbol: '₡', approxUsdRate: 520 },
  'panama': { code: 'USD', symbol: '$', approxUsdRate: 1 },
  'cuba': { code: 'CUP', symbol: 'CUP', approxUsdRate: 24 },
  'georgia': { code: 'GEL', symbol: '₾', approxUsdRate: 2.7 },
  'mongolia': { code: 'MNT', symbol: '₮', approxUsdRate: 3400 },
  'romania': { code: 'RON', symbol: 'lei', approxUsdRate: 4.7 },
  'serbia': { code: 'RSD', symbol: 'din', approxUsdRate: 110 },
  'montenegro': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'bosnia': { code: 'BAM', symbol: 'KM', approxUsdRate: 1.8 },
  // Gaps surfaced by UAT — Bhutan was rendering as "USD" because it was
  // missing here. INR is the de-facto trade currency, BTN is the local.
  'bhutan': { code: 'BTN', symbol: 'Nu', approxUsdRate: 84 },
  'seychelles': { code: 'SCR', symbol: 'SR', approxUsdRate: 14 },
  'mauritius': { code: 'MUR', symbol: '₨', approxUsdRate: 47 },
  'fiji': { code: 'FJD', symbol: 'FJ$', approxUsdRate: 2.3 },
  'botswana': { code: 'BWP', symbol: 'P', approxUsdRate: 13.5 },
  'namibia': { code: 'NAD', symbol: 'N$', approxUsdRate: 18 },
  'saudi arabia': { code: 'SAR', symbol: 'SR', approxUsdRate: 3.75 },
  'lebanon': { code: 'LBP', symbol: 'L£', approxUsdRate: 89500 },
  'iceland': { code: 'ISK', symbol: 'kr', approxUsdRate: 140 },
  'azerbaijan': { code: 'AZN', symbol: '₼', approxUsdRate: 1.7 },
  'armenia': { code: 'AMD', symbol: '֏', approxUsdRate: 390 },
  'uzbekistan': { code: 'UZS', symbol: 'soʻm', approxUsdRate: 12500 },
  'malta': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'cyprus': { code: 'EUR', symbol: '€', approxUsdRate: 0.92 },
  'myanmar': { code: 'MMK', symbol: 'K', approxUsdRate: 2100 },
  'laos': { code: 'LAK', symbol: '₭', approxUsdRate: 21000 },
  'madagascar': { code: 'MGA', symbol: 'Ar', approxUsdRate: 4500 },
  // Single-source-of-truth additions (PR #291): USA + Hong Kong were
  // previously only in travelInfoConstants.js. Now consolidated here so
  // travelInfoConstants.js + currencyUtils.js can derive their maps.
  'usa': { code: 'USD', symbol: '$', approxUsdRate: 1 },
  'united states': { code: 'USD', symbol: '$', approxUsdRate: 1 },
  'hong kong': { code: 'HKD', symbol: 'HK$', approxUsdRate: 7.8 },
};

/** Countries where USD is the primary or widely-accepted currency */
export const USD_ACCEPTED_COUNTRIES = [
  'united states', 'usa', 'ecuador', 'panama', 'el salvador',
  'maldives', 'cambodia', 'belize', 'turks and caicos', 'bermuda',
  'british virgin islands', 'us virgin islands', 'puerto rico',
  'marshall islands', 'palau', 'micronesia',
];

// ============================================
// PACE LIMITS — shared between normalizer and validator
// ============================================

export const PACE_LIMITS = {
  'very relaxed': { min: 1, max: 2 },
  'relaxed': { min: 2, max: 3 },
  'moderate': { min: 3, max: 4 },
  'fast': { min: 4, max: 5 },
  'packed': { min: 5, max: 6 },
};

// ============================================
// INTEREST KEYWORDS — map user interest category → activity keywords
// Used by the itinerary normalizer to score activities against the user's
// declared interests so pace-limit trimming keeps items that match.
// ============================================

export const INTEREST_KEYWORDS = {
  food: ['restaurant', 'cafe', 'market', 'tasting', 'cooking', 'wine', 'bakery', 'culinary', 'food', 'michelin', 'bistro', 'brasserie', 'pastry', 'chef', 'dinner', 'lunch', 'brunch'],
  culture: ['museum', 'gallery', 'temple', 'cathedral', 'palace', 'historic', 'ruins', 'monument', 'heritage', 'archaeological', 'landmark', 'basilica', 'synagogue', 'mosque', 'shrine', 'castle'],
  adventure: ['hike', 'trek', 'climb', 'kayak', 'surf', 'bike', 'dive', 'snorkel', 'safari', 'raft', 'zipline', 'canyon', 'canyoning', 'cycling', 'mountaineering'],
  nightlife: ['bar', 'pub', 'lounge', 'club', 'cocktail', 'rooftop', 'speakeasy', 'live music', 'jazz', 'nightclub'],
  nature: ['park', 'garden', 'trail', 'beach', 'lake', 'waterfall', 'mountain', 'viewpoint', 'forest', 'botanical', 'wildlife', 'nature reserve'],
  wellness: ['spa', 'yoga', 'sauna', 'hot spring', 'thermal', 'massage', 'onsen', 'hammam', 'meditation', 'wellness'],
  shopping: ['market', 'boutique', 'mall', 'shops', 'bazaar', 'souvenir', 'artisan', 'crafts'],
  family: ['zoo', 'aquarium', 'theme park', 'kid', 'children', 'playground', 'amusement', 'family-friendly'],
  photography: ['viewpoint', 'sunset', 'sunrise', 'scenic', 'panorama', 'observation deck', 'photogenic'],
  sports: ['stadium', 'match', 'game', 'golf', 'tennis', 'ski', 'snowboard'],
};
